export default __webpack_public_path__ + "static/media/well_lit.c62fb44e.webp";